import EfBanner from '@elem/ui/ef-banner';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.Banner');
    const { locale = 'jp' } = getLocal();
    const IS_CN = locale === 'cn';
    const itemA = {
        title: t('title'),
        desc: t('desc'),
        pc: IS_CN
            ? 'https://websiteoss.ecoflow.com/upload/image/1737611736834/banner-pc.jpg'
            : 'https://websiteoss.ecoflow.com/upload/image/1724560810206/banner-pc.jpg',
        h5: IS_CN
            ? 'https://websiteoss.ecoflow.com/upload/image/1737611736661/banner-h5.jpg'
            : 'https://websiteoss.ecoflow.com/upload/image/1724394604383/banner-h5.jpg',
        theme: 'black',
        btn_text: t('btn'),
        btn_link: IS_CN
            ? 'https://www.xiaohongshu.com/explore/66ed3597000000000c01a715?source=webshare&xhsshare=pc_web&xsec_token=ABbr0euMo13V-qwLLQnqrJmoy_wZcUT7bdsV_ZxduiJUE=&xsec_source=pc_share'
            : 'https://www.youtube.com/embed/MfmSTKQwacA?si=JlhUWFqL6nCV8a0K',
        isOpenLink: IS_CN ? true : false,
    };
    return (
        <div className={styles.TheComp}>
            <EfBanner {...itemA} />
        </div>
    );
}
